const selectTheme = ({theme, setTheme}) => {
    return (
    <div>
        <br />
        <select
            value={theme}
            onChange={(event) => {
                localStorage.setItem("gc-theme", event.target.value);
                setTheme(event.target.value);
                window.location.reload();
            }}
            className="form-control form-select"
        >
            <option value="bootstrap-v4">bootstrap-v4</option>
            <option value="bootstrap-v5">bootstrap-v5</option>
            <option value="grocery-crud-v1">grocery-crud-v1</option>
            <option value="materialize-v1">materialize-v1</option>
            <option value="tailwind-v2">tailwind-v2</option>
        </select>
    </div>
    );
};

export default selectTheme;